import dayjs from 'dayjs'
import { IDatepickerProps } from '@/types/common/datepicker'
import arraySupport from 'dayjs/plugin/arraySupport'

dayjs.extend(arraySupport)

export const useActions = (
  emit: (event: 'update:modelValue', ...args: string[]) => void,
  props: IDatepickerProps,
  day: typeof dayjs
) => {
  /**
   * 「クリア」ボタン押下
   */
  const handleClear = async (closePicker: () => void): Promise<void> => {
    emit('update:modelValue', '')
    closePicker()
  }
  /**
   * 月移動ボタンが非活性か
   * @param next
   * @param current [year, month(0-11)]
   */
  const isDisabledMonthYearButton = (next: boolean, current: [number, number]): boolean => {
    if (next && !props.maxDate) return false
    if (!next && !props.minDate) return false
    return next ? !day(current).isBefore(props.maxDate, 'month') : !day(current).isAfter(props.minDate, 'month')
  }

  return {
    handleClear: handleClear,
    isDisabledMonthYearButton: isDisabledMonthYearButton,
  }
}
